import branchManagementLocationHoldsComponent from './location_holds.component';

let branchManagementLocationHoldsModule = angular.module('branchManagementLocationHolds', [])
  .component('branchManagementLocationHolds', branchManagementLocationHoldsComponent)
  .name;

export default branchManagementLocationHoldsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/location_holds/index.js